/**
 * Tiny in-tab pub/sub bridging the Cart layer and the PDP promo banner.
 *
 * Shopware can accept a promotion code structurally yet reject it at
 * add-to-cart time (not applicable to the chosen product, min order value not
 * met, already redeemed, …). That rejection happens inside ShopwareContext,
 * far from the banner state in usePromoCode. This emitter lets the cart layer
 * notify the banner without threading state through the component tree.
 */

type PromoRejectedListener = (code: string) => void;

const listeners = new Set<PromoRejectedListener>();

export function onPromoRejected(listener: PromoRejectedListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyPromoRejected(code: string): void {
  for (const listener of listeners) {
    try {
      listener(code);
    } catch {
      // A broken listener must never break the cart flow.
    }
  }
}
